import { gql } from "@apollo/client";

// ============================================================================
// MUNICIPALITY QUERIES
// ============================================================================

import { GENERAL_FIELDS, SITE_FIELDS, PAGE_SETTINGS, MUNICIPALITY_FIELDS } from "./shared";
import { HERO_INTRO_IMAGE, HERO_INTRO_IMAGE_MOBILE } from "./fragments/heroIntroImage";

export const MUNICIPALITIES_OVERVIEW_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${PAGE_SETTINGS}
  ${MUNICIPALITY_FIELDS}
  ${HERO_INTRO_IMAGE}
  ${HERO_INTRO_IMAGE_MOBILE}
  query GetMunicipalities($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: municipalitiesOverview(locale: $locale) {
      # Municipalities Overview Meta (SEO)
      titles: _allTitleLocales(locale: $locale) {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # Municipalities Overview Fields (Content)
      title
      shortTitle
      intro {
        value
      }

      introImage {
        ...HeroIntroImage
      }
      introImageMobile: introImage {
        ...HeroIntroImageMobile
      }

      # Municipalities Overview Components
      pageSettings {
        ...PageSettings
      }
    }
    municipalities: allMunicipalities(
      locale: $locale
      first: 500
      orderBy: title_ASC
      filter: { _locales: { allIn: [$locale] } }
    ) {
      ...MunicipalityFields
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
    }
  }
`;

export const MUNICIPALITIES_QUERY = gql`
  ${MUNICIPALITY_FIELDS}
  query GetAllMunicipalities($locale: SiteLocale!, $limit: IntType!, $offset: IntType!) {
    allMunicipalities(locale: $locale, first: $limit, skip: $offset, orderBy: title_ASC) {
      ...MunicipalityFields
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
    }
  }
`;
